import PinSVG from "@design-system/ui-icons/vanilla/Pin"
import { createIcon } from "../createIcon"

export const PinIcon = createIcon(PinSVG)
